<template>
    <BlockUI :blocked="isLoading">
        <Fluid class="field">
            <label for="name">Name</label>
            <InputText
                id="name"
                autofocus
                v-model="newName"
                required
                :value="newName"
                style="width: 100%"
            />
        </Fluid>
        <div class="buttons">
            <Button label="Cancel" text severity="secondary" @click="cancel" />
            <Button label="Save" severity="primary" @click="closeAndSave" />
        </div>
    </BlockUI>
</template>

<script setup lang="ts">
import { Ref, ref, inject, onMounted } from "vue";
import { Role, useRolesStore, useRolesManager } from "@/stores/roles-store";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import InputText from "primevue/inputtext";
import { useHotKeys } from "@/composables/hotkeys";

const { createRole, updateRole } = useRolesStore();
const { statusCode, isLoading } = useRolesManager();
const { addHotKey } = useHotKeys();

const editRole = ref<Role>();
const newName = ref("");
const dialogRef = inject<Ref<DynamicDialogInstance>>("dialogRef");

const cancel = () => dialogRef?.value.close();
const closeAndSave = async () => {
    if (editRole.value) {
        await updateRole({
            identity: editRole.value.identity,
            name: newName.value,
        });
    } else {
        await createRole(newName.value);
    }
    if (statusCode.value < 300) dialogRef?.value.close();
};

onMounted(() => {
    editRole.value = dialogRef?.value.data;
    if (editRole.value) {
        newName.value = editRole.value.name;
    }
});

/**
 * Save and close on enter.
 */
addHotKey("ControlOrMeta+Enter", async () => {
    await closeAndSave();
});
</script>

<style lang="scss" scoped>
.field {
    padding-bottom: 1em;

    label {
        display: block;
        margin-bottom: 0.5em;
    }
}

.buttons {
    display: flex;
    justify-content: end;
    margin-top: 1em;
    gap: 1em;
}
</style>
